import { useSubscriptionExpired } from "src/hooks/use-subscription-expired";
import { canOpenWithoutSubscription } from "src/configs/subscription-access";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useAuth } from "src/hooks/use-auth";
import { UsageBuy } from "src/sections/dashboard/usage/usage-buy";
import { useLocation } from "react-router-dom";

export const UsageGuard = (props) => {
  const { children } = props;
  const { user } = useAuth();
  const location = useLocation();

  const expired = useSubscriptionExpired(user);
  if (expired && !canOpenWithoutSubscription(location.pathname)) {
    return <Box component="main" sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}>
      <UsageBuy />
    </Box>;
  }

  return <>{children}</>;
};

UsageGuard.propTypes = {
  children: PropTypes.node,
};
